'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);


var _PublishPropertyForm = require('./PublishPropertyForm.scss');var styles = _interopRequireWildcard(_PublishPropertyForm);
var _containers = require('../../containers');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // styles

var PublishAuthenticationBlock = function PublishAuthenticationBlock(props) {return (
    _react2.default.createElement('div', { className: styles.authenticationBlock },
      _react2.default.createElement('div', { className: styles.title }, props.label),
      _react2.default.createElement(_containers.PublishAuthenticationContainer, { isAgent: props.isAgent })));};



PublishAuthenticationBlock.propTypes = {
  isAgent: _propTypes2.default.bool,
  label: _propTypes2.default.string };exports.default =


PublishAuthenticationBlock;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishForm/PublishAuthenticationBlock.js
// module id = 3025
// module chunks = 0